module.exports = __webpack_public_path__ + "static/media/sample-auction.4191f6be.xlsx";